export const items = [
    {
        "key": "countdown",
        "title": "9월 23일부터 12월 31일까지/100일 남았어요!",
        "narrator": "064. 9월 23일부터 12월 31일까지 100일 남았어요! | 낭독 봉현",
        "keywords": ["단정한 반복", "단순한 기쁨"],
        "qrUrl": "/qr/3.svg",
        "audioUrl": "/audio/countdown.mp3",
        "audioTitle": "봉현읽기",
        "imageURL": "/images/countdown.png",
        "endingImageURL": "/images/countdown_end.svg",
        "imageBackground": "#4F4F4F",
        "highlightColor": "#FCF0BD",
        "transcript": [
            [{
                "start": 0,
                "end": 7,
                "text": "12월 31일 마지막 날까지 반드시 100장의 그림을 그려낼 것이다."
            },
            {
                "start": 7,
                "end": 13,
                "text": "우리는 /모두 어떤 방식으로든 꾸준하고 성실하다."
            },
            {
                "start": 13,
                "end": 21,
                "text": "나처럼 그림이 아니어도 다양한 /방법으로 각자의 이유로 무언가를 남긴다."
            },
            {
                "start": 21,
                "end": 31,
                "text": "찰나의 순간을 사진 찍고,/아무도 알아주지 않을 진심을 편지에 적고, 지나간 시간을 글로 기록한다."
            },],
            [{
                "start": 31,
                "end": 47,
                "text": "무엇보다 명확한 결과물이 없다 할지라도, 매일 잠을 자고 밥을 먹으며/하루를 살아가는 모든 사람의 매일은 꾸준하고 성실하며 가치 있다."
            },
            {
                "start": 47,
                "end": 51,
                "text": "/그런 오늘의 나는 언제나 사랑스럽다."
            },
            {
                "start": 51,
                "end": 53,
                "text": "어떤 모습이어도."
            }]
        ]

    },
    {
        "key": "home",
        "title": "당신의 집에도 있다",
        "narrator": "[Blind Essay Project] epilogue, 당신의 집에도 있다  I  낭독 송근영",
        "keywords": ["밝은 시선", "공감 능력"],
        "qrUrl": "/qr/1.svg",
        "audioUrl": "/audio/home.mp3",
        "audioTitle": "턱괴는레터",
        "imageURL": "/images/home.png",
        "endingImageURL": "/images/home_end.svg",
        "imageBackground": "#654D3C",
        "highlightColor": "#ECDAD1",
        "transcript": [
            [{
                "start": 0,
                "end": 20,
                "text": "나는 전시장을 지키며 매일같이 카로우 셰지아크가 담아낸 다채로운 /주름을 가진 주인공들에 대해, 그들의 삶의 데이터가 응축된 도서관과도 /같은 1.5평의 방에 대해, 그리고 그들의 방문을 두드린 카로우 셰지아크에 /대해 꼬리를 물며 생각한다."
            },],
            [{
                "start": 20,
                "end": 33,
                "text": "노년에 대한 이 ‘낯섦’의 긍정적이고 부정적인 면들- 미래에 남겨진 /무한한 발견과 과거에 무수히 쌓인 편협한 편린들을 되새김질한다."
            },
            {
                "start": 33,
                "end": 45,
                "text": "/왜 우리가 목격하고 학습할 수 있는 노년은 단지 우리의 조부모뿐이었는지, 왜 ‘나이 듦’을 우울하고 걱정되는 것으로 받아들이게 되었는지."
            },],
            [{
                "start": 45,
                "end": 59,
                "text": "우리는 늘 우리가 누군지 좇고 무엇을 하고 싶은지 생각할 텐데, /왜 이러한 욕망의 품이 나에 대해 많이 알아갈수록 신나지 않고 되려 /반비례하는 것처럼 생각하게 되는지 질문을 던진다."
            },]
        ]

    },
    {
        "key": "movie",
        "title": "미루어진 영화",
        "narrator": "미루어진 영화 I 낭독 윤성용",
        "keywords": ["일상에 대한 애정", "사소한 것을 대하는 다정함"],
        "qrUrl": "/qr/4.svg",
        "audioUrl": "/audio/movie.mp3",
        "audioTitle": "xyzorba",
        "imageURL": "/images/movie.png",
        "endingImageURL": "/images/movie_end.svg",
        "imageBackground": "#56839D",
        "highlightColor": "#D7F2FF",
        "transcript": [
            [{
                "start": 0,
                "end": 9,
                "text": "어떤 영화는 첫 장면부터 마음을 사로잡고, 어떤 영화는 끝까지 봐도 큰 /감흥이 없는 경우도 있다."
            },
            {
                "start": 9,
                "end": 16,
                "text": "하지만 중요한 건 그 과정을 통해 새로운 시각과 감정을 경험하게 된다는 것이다."
            },
            {
                "start": 16,
                "end": 26,
                "text": "예를 들어, 영화 <택시 드라이버>를 통해서는 인간의 내면 깊숙한 곳에 숨겨진 복잡한 감정을 들여다볼 수 있었다."
            },],
            [{
                "start": 26,
                "end": 30,
                "text": "이러한 경험들이 쌓여 나를 더 풍부하게 만든다."
            },
            {
                "start": 30,
                "end": 37,
                "text": "그걸 알면서도, 혹은 그걸 알기 때문에 다가가기가 더 어렵다."
            },
            {
                "start": 37,
                "end": 42,
                "text": "불확실하고 예상치 못한 것들이 점점 /더 어려워진다."
            },
            {
                "start": 42,
                "end": 46,
                "text": "여전히 보관함에 남아있는 영화들도 많다."
            },
            {
                "start": 46,
                "end": 54,
                "text": "내게 감동과 /영감을 전해줄 영화들이 나를 기다리다 지친 아이처럼 잠들어 있다."
            },],
            [{
                "start": 54,
                "end": 61,
                "text": "영화 <윤희에게>가 그렇고, <시티 오브 갓>이 그렇고, <반칙왕>이 /그렇다."
            },
            {
                "start": 61,
                "end": 67,
                "text": "그 속에는 내가 미처 알지 못했던 세계와 이야기가 숨어 있다."
            },
            {
                "start": 67,
                "end": 75,
                "text": "/어쩌면 이 영화들은 내가 용기를 내어 다가가기를 기다리고 있었는지도 /모른다."
            },],
            [{
                "start": 75,
                "end": 82,
                "text": "나는 오늘도 보관함에 들어가 잠든 얼굴을 쓰다듬어 주고 어두운 방을 /나온다."
            },
            {
                "start": 82,
                "end": 88,
                "text": "내일은 그중 하나를 꼭 깨워봐야겠다고 다짐해 본다."
            }]
        ]

    },
    {
        "key": "day",
        "title": "매일 똑같고 다른 하루의/궤적을 따라",
        "narrator": "068. 매일 똑같고 다른 하루의 궤적을 따라 | 낭독 봉현",
        "keywords": ["단정한 반복", "단순한 기쁨"],
        "qrUrl": "/qr/3.svg",
        "audioUrl": "/audio/day.mp3",
        "audioTitle": "봉현읽기",
        "imageURL": "/images/day.png",
        "endingImageURL": "/images/day_end.svg",
        "imageBackground": "#AFCAEA",
        "highlightColor": "#D1E6FF",
        "transcript": [
            [{
                "start": 0,
                "end": 2,
                "text": "이제는 알아요."
            },
            {
                "start": 2,
                "end": 8,
                "text": "성장과 발전은 꾸준함과 안정감이 뒷받침되어야만 합니다."
            },
            {
                "start": 8,
                "end": 21,
                "text": "그렇기에 내가 머무는 집, 내가 먹는 음식, 내가 만나는 사람, /내 삶의 방식 같은- 지금의 것들을 지켜내야만 합니다."
            },],
            [{
                "start": 21,
                "end": 32,
                "text": "진전하는 것에만 몰두하지 말고, 위를 바라보는 것만 매달리지 말고, /중심의 끈을 팽팽하게 잘 잡아당기고 있어야 해요."
            },
            {
                "start": 32,
                "end": 44,
                "text": "그리고 아주 조금씩, /적당한 힘으로 꼭 붙잡은 채로- 천천히 나아가고, 한발 한발 올라가는 거죠."
            },
            {
                "start": 44,
                "end": 48,
                "text": "암벽 등반 같은 기분이 들더라도요."
            }]
        ]

    },
    {
        "key": "love",
        "title": "사랑합니다",
        "narrator": "#229 사랑합니다 | 낭독 김세영",
        "keywords": ["인문학", "사유의 기쁨"],
        "qrUrl": "/qr/5.svg",
        "audioUrl": "/audio/love.mp3",
        "audioTitle": "한편",
        "imageURL": "/images/love.png",
        "endingImageURL": "/images/love_end.svg",
        "imageBackground": "#4A4A4A",
        "highlightColor": "#E9E4CB",
        "transcript": [
            [{
                "start": 0,
                "end": 14,
                "text": "썩은 고깃덩어리, 절단되고 피가 나는 시체, 뒤틀린 얼굴을 그린 화가 /프랜시스 베이컨은 사람들의 생각과 달리 자신이 공포를 부각시켜 /표현하지 않았다고 말합니다."
            },
            {
                "start": 14,
                "end": 22,
                "text": "오히려 그는 입안의 색감, 정육점에 걸린 /고깃덩어리의 빛깔에서 아름다움을 느꼈다고 해요."
            },],
            [{
                "start": 22,
                "end": 35,
                "text": "그것들을 들여다보고 있으면 우리가 모두 잠재적인 시체라는 사실이, /다른 생명을 잡아먹고 사는 삶에 깃든 공포가 자연스레 떠오르게 된다는 /것이죠."
            },],
            [{
                "start": 35,
                "end": 46,
                "text": "정육점에서 매일같이 마주치는 고깃덩어리와 해양 포유류의 이야기를 /함께 놓고, 지금 여기에서 무엇이 더 가능한지 생각해 보고 싶어요."
            }]
        ]

    },
    {
        "key": "weekend",
        "title": "아무것도 하지 않은/주말",
        "narrator": "#215 아무것도 하지 않은 주말 | 낭독 맹미선",
        "keywords": ["인문학", "사유의 기쁨"],
        "qrUrl": "/qr/5.svg",
        "audioUrl": "/audio/weekend.mp3",
        "audioTitle": "한편",
        "imageURL": "/images/weekend.png",
        "endingImageURL": "/images/weekend_end.svg",
        "imageBackground": "#78736D",
        "highlightColor": "#E5DDD1",
        "transcript": [
            [{
                "start": 0,
                "end": 7,
                "text": "여러분은 ‘귀농’, ‘주말 농장’, ‘도시 텃밭’ 하면 어떤 생각이 드세요?"
            },
            {
                "start": 7,
                "end": 15,
                "text": "/저는 저의 것과 너무나 다른 라이프스타일에 약간은 거리감을 느끼게 /되는데요."
            },
            {
                "start": 15,
                "end": 25,
                "text": "‘텃밭 가꾸기라는 취미는 쉬는 게 아니라 또 다른 일 아닌가?’/라는 생각이 꼬리를 물어 ‘가계에 도움 되는 일이라 좋은 건가?’,"
            },],
            [{
                "start": 25,
                "end": 33,
                "text": "‘평소에 그렇게 일을 하고도 또 일을 한다고?’라는 의문에 이르곤 해요."
            },
            {
                "start": 33,
                "end": 44,
                "text": "/화폐가 아닌 삶에 필요한 것을 직접 생산하고 교환하는 분들의 /이야기를 통해 이러한 평소 생각을 다른 각도로 궁리해 볼 수 있었습니다."
            },
            {
                "start": 44,
                "end": 49,
                "text": "물론 한 번의 대화만으로 도시의 임금노동자인 내가"
            },],
            [{
                "start": 49,
                "end": 55,
                "text": "일 생각, 자기 계발 생각에서 자유로워질 수 있는 묘책을 얻은 것은 /아니었습니다."
            },
            {
                "start": 55,
                "end": 67,
                "text": "다만 얼마만큼 생산할 것인가, 한정적인 조건에 얼마나 /나를 쥐어짤 것인가는 내 마음가짐에 달렸다는 생각을 해 보았지요."
            },],
            [{
                "start": 67,
                "end": 78,
                "text": "성인이 되고서야 비로소 본 「나루토」 완결권은 어딘가 허무한 면도 /있었지만, 그 허무한 시간도 그대로 흘려보내기로 했습니다."
            },]
        ]

    },
    {
        "key": "people",
        "title": "여기 기꺼이 시도하는/사람들이 있다",
        "narrator": "[Blind Essay Project] prologue, 여기 기꺼이 시도하는 사람들이 있다 I 낭독 정수경",
        "keywords": ["밝은 시선", "공감 능력"],
        "qrUrl": "/qr/1.svg",
        "audioUrl": "/audio/people.mp3",
        "audioTitle": "턱괴는레터",
        "imageURL": "/images/people.png",
        "endingImageURL": "/images/people_end.svg",
        "imageBackground": "#D57C4A",
        "highlightColor": "#FFDECC",
        "transcript": [
            [{
                "start": 0,
                "end": 7,
                "text": "사전적 정의로 외로움은 홀로 되어 쓸쓸한 ‘마음’이나 ‘느낌’을 말한다."
            },
            {
                "start": 7,
                "end": 9,
                "text": "/외로움은 고독과도 다르다."
            },
            {
                "start": 9,
                "end": 14,
                "text": "철학적으로 고독은 자신의 깊은 내면으로 /들어가는 거다."
            },
            {
                "start": 14,
                "end": 18,
                "text": "’스스로’ 들어간다는 점이 중요하다."
            },
            {
                "start": 18,
                "end": 23,
                "text": "그러나 외로움은 /주변에서 자신이 고립되는 양상이다."
            },
            {
                "start": 23,
                "end": 29,
                "text": "자의성과 타의성이라는 차이가 있다."
            },],
            [{
                "start": 29,
                "end": 43,
                "text": "여자야구 선수들에게 야구장처럼, 사회에서 지워진 노인들에게 할당된 /양로시설처럼, 어떤 장소나 집단에서 대상이 지워질 때, 소외의 결과로 /외로움이 생성된다."
            },
            {
                "start": 43,
                "end": 52,
                "text": "턱괴는여자들로 모인 나와 동료들은 외로움에는 /마음이나 느낌보다 더 입체적인 형상이 있다고 여긴다."
            },],
            [{
                "start": 52,
                "end": 53,
                "text": "그렇다."
            },
            {
                "start": 53,
                "end": 57,
                "text": "외로움이란 구조적으로 형성된다."
            },
            {
                "start": 57,
                "end": 61,
                "text": "사전적 정의를 당장 우리의 /가설로 덮고 싶지는 않다."
            },
            {
                "start": 61,
                "end": 63,
                "text": "그럴 역량도 없다."
            },
            {
                "start": 63,
                "end": 74,
                "text": "다만, 새로운 접근 방법이 /필요하다는 점에서, 외로움을 파헤치는 첫 번째 방법론으로 /’에세이’를 골랐다."
            }]
        ]
    },
    {
        "key": "omo",
        "title": "오모씨의 일일",
        "narrator": "오모씨의 일일 | 낭독 오지윤",
        "keywords": ["받는이를 위한 편지", "일상의 장면"],
        "qrUrl": "/qr/2.svg",
        "audioUrl": "/audio/omo.mp3",
        "audioTitle": "보낸이 오지윤",
        "imageURL": "/images/omo.png",
        "endingImageURL": "/images/omo_end.svg",
        "imageBackground": "#D65752",
        "highlightColor": "#FFDAD9",
        "transcript": [
            [{
                "start": 0,
                "end": 10,
                "text": "초등학교 5학년 때 겨울 방학 숙제를 하기 위해, 엄마와 장욱진 화백의 /전시를 보러 갔었다."
            },
            {
                "start": 10,
                "end": 15,
                "text": "나는 연한 머스타드 코트를 입고, 에메랄드색 골덴 /바지를 입고 있었다."
            },
            {
                "start": 15,
                "end": 21,
                "text": "엄마가 찍어준 사진 덕분에 기억한다."
            },
            {
                "start": 21,
                "end": 26,
                "text": "숙제를 하기 /위해 설렁설렁 보기에는 인상 깊은 그림이 많았다."
            },],
            [{
                "start": 26,
                "end": 29,
                "text": "순수한 할아버지의 순수한 그림."
            },
            {
                "start": 29,
                "end": 36,
                "text": "그림과 작가에 대한 설명이 읽기 쉬웠고 /그림도 참 쉬웠다."
            },
            {
                "start": 36,
                "end": 40,
                "text": "장욱진이라는 화가가 믿을만한 어른이라고 생각했다."
            },
            {
                "start": 40,
                "end": 46,
                "text": "/그때는 믿음직했던 할아버지가, 이제는 닮고 싶은 선배가 됐다."
            },],
            [{
                "start": 46,
                "end": 54,
                "text": "어릴 때 봤던 장욱진 화가의 얼굴도 우리 할아버지를 닮았었는데, 밝게 /웃는 주름이 또 닮았다."
            },
            {
                "start": 54,
                "end": 60,
                "text": "산골에서 쪼그려 앉아 담배 피는 모습도 할아버지를 꼭 닮았다."
            },
            {
                "start": 60,
                "end": 65,
                "text": "화가는 ‘심플’하게 살겠다는 말을 자주 했다고 한다."
            },
            {
                "start": 65,
                "end": 69,
                "text": "활자와 삶이 일치하는 사람은 보기 드물다."
            },
            {
                "start": 69,
                "end": 84,
                "text": "보기 드문 사람을 만난 날이다."
            }]
        ]

    },
    {
        "key": "lost",
        "title": "잃어버린 것과/얻은 것",
        "narrator": "잃어버린 것과 얻은 것 | 낭독 윤성용",
        "keywords": ["일상에 대한 애정", "사소한 것을 대하는 다정함"],
        "qrUrl": "/qr/4.svg",
        "audioUrl": "/audio/lost.mp3",
        "audioTitle": "xyzorba",
        "imageURL": "/images/lost.png",
        "endingImageURL": "/images/lost_end.svg",
        "imageBackground": "#727272",
        "highlightColor": "#D7F2FF",
        "transcript": [
            [{
                "start": 0,
                "end": 7,
                "text": "좋게 보면 단단한 사람이 되었고, 나쁘게 보면 지루한 사람이 /되어버린 것 같다."
            },
            {
                "start": 7,
                "end": 13,
                "text": "하지만 좋게 보려는 마음이 없다면 어떤 것이든 /좋아 보일 수는 없을 것이다."
            },],
            [{
                "start": 13,
                "end": 27,
                "text": "예를 들어 무뎌졌다는 건 예민한 감각을 잃은 것이기도 하지만, /이전과 달리 어떤 상처와 불안에도 견딜만한 힘이 생겼다는 것이기도 하다."
            },
            {
                "start": 27,
                "end": 32,
                "text": "잃어버린 것과 얻은 것 사이에 나의 삶은 조금씩 흘러간다."
            },],
            [{
                "start": 32,
                "end": 40,
                "text": "나는 그 사이에서 겨우 균형을 맞추며 조금씩 나아가고 있다."
            },
            {
                "start": 40,
                "end": 50,
                "text": "/‘잃은 만큼 정확히 채워진다.’라고 생각하면 언제나 내 곁을 맴도는 /서글픈 마음도 조금은 가라앉는 듯하다."
            }]
        ]

    },
    {
        "key": "referral",
        "title": "의뢰서를/만들었습니다",
        "narrator": "프리레터.13_ 의뢰서를 만들었습니다. I 낭독 엄주",
        "keywords": ["프리랜서의 일", "정체성"],
        "audioUrl": "/audio/referral.mp3",
        "audioTitle": "프리레터",
        "imageURL": "/images/referral.png",
        "endingImageURL": "/images/referral_end.svg",
        "imageBackground": "#B95F4A",
        "highlightColor": "#FFD6CC",
        "transcript": [
            [{
                "start": 0,
                "end": 6,
                "text": "경험으로 보아 프리랜서가 활동하기에, 한국은 수월한 곳이 아니다."
            },
            {
                "start": 6,
                "end": 19,
                "text": "/‘빨리빨리’의 민족답게 일정이 급박한 곳이 많고, 체계가 없고 위계로 /사람을 압박하는 곳도 많은 편이라 내부 분위기가 정규직원도 일하기 좋은 환경이 아니기에 때에 따라 외주작가는 그야말로 경우에 따라"
            },],
            [{
                "start": 19,
                "end": 22,
                "text": "꿔다 놓은 보릿자루 신세가 되는 경우가 많다."
            },
            {
                "start": 22,
                "end": 28,
                "text": "안타깝게도 내가 챙길 수 /있는 것은 적극적으로 먼저 찾아야지만 그나마 본전을 챙길 수 있다."
            },
            {
                "start": 28,
                "end": 33,
                "text": "/은은하게 깔려있는 불안을 해소할 수 있는 방법은 의뢰서를 만들어 사전 /정보를 받는 것이고,"
            },],
            [{
                "start": 33,
                "end": 39,
                "text": "계약서를 신경 써서 작성하여 미래에 일어날 불상사를 막는 것 밖에는 /장치가 없다."
            },
            {
                "start": 39,
                "end": 51,
                "text": "진행하려는 일의 법적인 검토와 비용의 부분은 온전히 /혼자 감당해야 하는 것이 프리랜서라 스스로 보호할 수 있는 장치는 /되도록 일 시작 전에 만들어 놓는 것을 추천한다."
            },]
        ]

    },
    {
        "key": "vacation",
        "title": "첫 휴가 2",
        "narrator": "첫 휴가 - 2 | 낭독 오지윤",
        "keywords": ["받는이를 위한 편지", "일상의 장면"],
        "qrUrl": "/qr/2.svg",
        "audioUrl": "/audio/vacation.mp3",
        "audioTitle": "보낸이 오지윤",
        "imageURL": "/images/vacation.png",
        "endingImageURL": "/images/vacation_end.svg",
        "imageBackground": "#0B7BA8",
        "highlightColor": "#C7E8F5",
        "transcript": [
            [{
                "start": 0,
                "end": 8,
                "text": "11월의 상트페테르부르크는 ‘끝의 정서’를 품고 잔뜩 웅크린 그림자 /같았다."
            },
            {
                "start": 8,
                "end": 15,
                "text": "지하철의 조명은 어두운 초록빛이었고 사람들은 모두 검은 외투를 입고 있었다."
            },
            {
                "start": 15,
                "end": 22,
                "text": "한국 사람들도 검은 외투를 좋아하니까 비슷하다면 비슷한 /풍경인데 무언가 다르다."
            },],
            [{
                "start": 22,
                "end": 28,
                "text": "마트의 계산원 아주머니는 잔돈을 던져버리고는 묘한 미소를 보였다."
            },
            {
                "start": 28,
                "end": 33,
                "text": "/행동은 괴팍한데 미소는 친절해서 혼란한 풍경."
            },
            {
                "start": 33,
                "end": 41,
                "text": "어떤 할머니는 푸틴이 /그려진 에코백을 메고 있었고, 지하철역에는 푸틴의 기념품을 파는 /가게가 있었다."
            },],
            [{
                "start": 41,
                "end": 50,
                "text": "웃통을 벗은 푸틴이 말을 타고 달려가는 사진이 티셔츠에도, 머그컵에도, /가방에도 새겨져 있었다."
            },
            {
                "start": 50,
                "end": 59,
                "text": "이 모든 게 11월의 러시아와 이상하게 /잘 어울렸고, 첫 휴가로 이곳에 오길 참 잘했다는 생각이 들었다."
            },],
            [{
                "start": 59,
                "end": 63,
                "text": "‘이국적’이라는 표현을 넘어서는 극도의 ‘이질감’."
            },
            {
                "start": 63,
                "end": 68,
                "text": "첫 휴가에 정말 필요한 /감정 아닌가?"
            }]
        ]

    },
    {
        "key": "freelancer",
        "title": "프리랜서 10년차/자아분열이 오기 시작했다",
        "narrator": "프리랜서 10년차, 자아분열이 오기 시작했다. I 낭독 엄주",
        "keywords": ["프리랜서의 일", "정체성"],
        "audioUrl": "/audio/freelancer.mp3",
        "audioTitle": "프리레터",
        "imageURL": "/images/freelancer.png",
        "endingImageURL": "/images/freelancer_end.svg",
        "imageBackground": "#27559F",
        "highlightColor": "#CFE1FF",
        "transcript": [
            [{
                "start": 0,
                "end": 15,
                "text": "조금씩 나아지는 나를 보는 게 인생의 목적이었던 시절에서 꽤 멀어진 /지금의 나는, 이제 스스로가 작가인지 자영업자인지 혹은 어디에 더 가까운 사람인지 셈하느라 그림을 순수하게 사랑했던 마음을 잊어버렸다."
            },],
            [{
                "start": 15,
                "end": 24,
                "text": "돈을 두고 흥정을 해야 하는지 그림을 두고 가치를 따져야 하는지 혼자 /자문자답하다가 질문도 답도 잊어버린 사람이 되었다."
            },
            {
                "start": 24,
                "end": 34,
                "text": "물론 누군가 볼 때는 좋아하는 일로 돈도 버는 일석이조의 삶을 사는 것처럼 보여, /좋아하는 것을 업으로 삼는 자의 행복한 비명이라고 할 수도 있다."
            },],
            [{
                "start": 34,
                "end": 43,
                "text": "그러나 10년 차 프리랜서의 삶을 맞은 지금은 그냥 어떤 것도 ‘일’이 /되면 가장 괴로운 ‘일’이 된다고 자신 있게 말할 수 있다."
            }]
        ]

    },
]
